export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000',
  siteOrigin: 'http://localhost:4200'
};
